module.exports = __webpack_public_path__ + "images/internal/campaign_steps/contacts.svg";